<template>
  <vue-select
    @search="searchUser"
    v-model="model"
    :options="!selectAll ? filteredUsers : []"
    name="users"
    v-validate="'required'"
    label="name"
    append-to-body
    :searchable="!selectAll"
    :multiple="!selectAll"
    :clearable="!selectAll"
  >
    <span slot="no-options" v-if="selectAll"> Selected All Users</span>
    <template #list-header>
      <v-checkbox class="mx-3" v-model="selectAll" @change="!selectAll">
        <template v-slot:label>
          <span class="ml-2 mt-1">Select All</span>
        </template>
      </v-checkbox>
    </template>
    <template #list-footer v-if="!selectAll">
      <div
        v-observe-visibility="fetchList"
        v-if="users.length < total"
        class="loader"
      >
        loading more options...
      </div>
    </template>
    <template #header>
      <div>Assign to Users</div>
    </template>
  </vue-select>
</template>

<script>
import {
  each as _each,
  findIndex as _findIndex,
  debounce as _debounce,
  isEmpty as _isEmpty,
} from 'lodash-es';

export default {
  name: 'AssignDropdown',
  props: ['value', 'setDropDownValue'],
  data() {
    return {
      selectAll: false,
      observer: null,
      limit: 10,
      users: [],
      loading: false,
      total: 10,
      page: 1,
      search: '',
    };
  },
  watch: {
    selectAll(val) {
      if (val) {
        this.setDropDownValue('Selected all');
      } else {
        this.setDropDownValue();
      }
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    // this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.selectAll) {
          this.setDropDownValue('Selected all');
        } else {
          this.setDropDownValue(value);
        }
      },
    },
    hasNextPage() {
      return this.users.length < this.total;
    },
    filteredUsers() {
      if (this.search) {
        return this.users.filter((user) =>
          user.name.toLowerCase().includes(this.search)
        );
      }
      return this.users;
    },
  },
  methods: {
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
      }
    },
    async fetchList(isVisible, entry) {
      if (isVisible) {
        const ul = entry.target.offsetParent;
        const { scrollTop } = entry.target.offsetParent;
        this.page += 1;
        await this.$nextTick();
        await this.getData();
        // ul.scrollTop = scrollTop;
      }
    },
    searchUser: _debounce(function (user) {
      this.search = user;
      this.getData();
    }, 500),
    async getData() {
      this.loading = true;
      await this.$http
        .get('get-random-users', {
          params: {
            users: 10,
            search: this.search,
            page: _isEmpty(this.search) ? this.page : 1,
          },
        })
        .then(({ data }) => {
          if (_isEmpty(this.search)) {
            this.total = data.total;
          }
          _each(data.data, (user) => {
            const index = _findIndex(this.users, { id: user.id });
            if (index === -1) {
              this.users.push(user);
            }
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="stylus">
.loader
  text-align: center
  color: #bbbbbb
.vs__dropdown-menu
  max-height: 20px !important
  min-height: 20px !important
</style>
